import { render, staticRenderFns } from "./purchasesOrder.vue?vue&type=template&id=0a0cb0ff&scoped=true&"
import script from "./purchasesOrder.vue?vue&type=script&lang=js&"
export * from "./purchasesOrder.vue?vue&type=script&lang=js&"
import style0 from "./purchasesOrder.vue?vue&type=style&index=0&id=0a0cb0ff&lang=less&scoped=true&"
import style1 from "./purchasesOrder.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0cb0ff",
  null
  
)

component.options.__file = "purchasesOrder.vue"
export default component.exports